import { c as _c } from "react/compiler-runtime";
import { Dialog as SheetPrimitive } from "radix-ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogTitle } from "@osmix/ui/dialog";
import { MaximizeIcon, Minus20Icon, MinusCircleIcon, Plus20Icon, PlusCircleIcon, XIcon } from "@/components/icons";
import { PhotoZoom } from "@/components/product/photo-zoom";
import { Button } from "@/components/ui/button";
import { useFormatPrice } from "@/lib/use-format-price";
import { cn } from "@/lib/utils";
export type CustomizationOption = {
  name: string;
  minPrice: number;
  photo?: string;
};

/*
 * «Этот товар можно изменить» — таблица кастомизации, которая выплывает слева
 * после «В корзину» (кадры 3870:26009, 3870:26442; борд §2.2).
 *
 * Панель 610 белая поверх затемнения 20 % с размытием 3px. Шапка 20/23 w600 с
 * крестиком 24. Таблица: заголовки «Изменение / Цена / Кол-во, шт» 14/18 w600
 * с линией #000 10 % снизу; строки 58 r29 с фото-кружком 50 (лупа — открыть
 * фото), название и цена 14/18, «⊖ N ⊕» 24. Выбранная строка — заливка
 * tangelo 5 % и обводка tangelo 0,5. Когда выбрано хоть одно изменение — сводка
 * «Изменение добавлено в корзину»: товар, кастомизация, «Итого» 20/23. Внизу
 * «В чат» (серая 150×48) и счётчик товара в корзине (тёмный 150×48).
 *
 * Цены здесь справочные: в корзину уходят только название и количество, сумму
 * считает сервер по карточке товара.
 */
export function CustomizationSheet(t0) {
  const $ = _c(129);
  const {
    open,
    onOpenChange,
    options,
    picked,
    onPick,
    unitPrice,
    qty,
    onQty,
    qtyBusy,
    canAddMore,
    applying,
    onChat
  } = t0;
  const {
    t
  } = useTranslation();
  const fmt = useFormatPrice();
  const [zoom, setZoom] = useState(null);
  let T0;
  let T1;
  let T2;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== applying || $[1] !== fmt || $[2] !== onOpenChange || $[3] !== onPick || $[4] !== open || $[5] !== options || $[6] !== picked || $[7] !== qty || $[8] !== t || $[9] !== unitPrice) {
    let t9;
    if ($[21] !== picked) {
      t9 = option => ({
        ...option,
        qty: picked[option.name] ?? 0
      });
      $[21] = picked;
      $[22] = t9;
    } else {
      t9 = $[22];
    }
    const chosen = options.map(t9).filter(_temp);
    const chosenCount = chosen.reduce(_temp2, 0);
    const chosenSum = chosen.reduce(_temp3, 0);
    const goodsSum = unitPrice * Math.max(qty, 1);
    T2 = SheetPrimitive.Root;
    t7 = open;
    t8 = onOpenChange;
    T1 = SheetPrimitive.Portal;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <SheetPrimitive.Overlay className="fixed inset-0 z-50 bg-black/20 backdrop-blur-[3px] data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0" />;
      $[23] = t6;
    } else {
      t6 = $[23];
    }
    T0 = SheetPrimitive.Content;
    t1 = "customization-sheet";
    t2 = "fixed inset-y-0 left-0 z-50 flex w-full max-w-[610px] flex-col bg-white outline-none data-[state=closed]:animate-out data-[state=closed]:slide-out-to-left data-[state=closed]:duration-300 data-[state=open]:animate-in data-[state=open]:slide-in-from-left data-[state=open]:duration-500";
    let t10;
    if ($[24] !== t) {
      t10 = t("product.customizeTitle", {
        defaultValue: "\u042D\u0442\u043E\u0442 \u0442\u043E\u0432\u0430\u0440 \u043C\u043E\u0436\u043D\u043E \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C"
      });
      $[24] = t;
      $[25] = t10;
    } else {
      t10 = $[25];
    }
    let t11;
    if ($[26] !== t10) {
      t11 = <SheetPrimitive.Title className="min-w-0 flex-1 text-[20px] font-semibold leading-[23px] tracking-[-0.31px] text-[#2E2E2E]">{t10}</SheetPrimitive.Title>;
      $[26] = t10;
      $[27] = t11;
    } else {
      t11 = $[27];
    }
    let t12;
    if ($[28] !== t) {
      t12 = t("product.customizeHint", {
        defaultValue: "\u0427\u0442\u043E\u0431\u044B \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0432 \u0442\u043E\u0432\u0430\u0440 \u043D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0443 \u0441\u0432\u043E\u0438 \u043F\u043E\u0436\u0435\u043B\u0430\u043D\u0438\u044F \u0432 \u0447\u0430\u0442\u0435."
      });
      $[28] = t;
      $[29] = t12;
    } else {
      t12 = $[29];
    }
    let t13;
    if ($[30] !== t12) {
      t13 = <SheetPrimitive.Description className="sr-only">{t12}</SheetPrimitive.Description>;
      $[30] = t12;
      $[31] = t13;
    } else {
      t13 = $[31];
    }
    let t14;
    if ($[32] !== t) {
      t14 = t("common.close", {
        defaultValue: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
      });
      $[32] = t;
      $[33] = t14;
    } else {
      t14 = $[33];
    }
    let t15;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <XIcon />;
      $[34] = t15;
    } else {
      t15 = $[34];
    }
    let t16;
    if ($[35] !== t14) {
      t16 = <SheetPrimitive.Close aria-label={t14} className="grid size-6 shrink-0 place-items-center rounded-[4px] text-[#1F1F1F] outline-none hover:text-osmix-tangelo focus-visible:ring-2 focus-visible:ring-ds-focus">{t15}</SheetPrimitive.Close>;
      $[35] = t14;
      $[36] = t16;
    } else {
      t16 = $[36];
    }
    if ($[37] !== t11 || $[38] !== t13 || $[39] !== t16) {
      t3 = <header className="flex items-start gap-6 pt-[30px] pr-5 pb-2.5 pl-4 sm:pl-[30px]">{t11}{t13}{t16}</header>;
      $[37] = t11;
      $[38] = t13;
      $[39] = t16;
      $[40] = t3;
    } else {
      t3 = $[40];
    }
    let t17;
    if ($[41] !== t) {
      t17 = t("product.customizeColName", {
        defaultValue: "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435"
      });
      $[41] = t;
      $[42] = t17;
    } else {
      t17 = $[42];
    }
    let t18;
    if ($[43] !== t17) {
      t18 = <span>{t17}</span>;
      $[43] = t17;
      $[44] = t18;
    } else {
      t18 = $[44];
    }
    let t19;
    if ($[45] !== t) {
      t19 = t("product.customizeColPrice", {
        defaultValue: "\u0426\u0435\u043D\u0430"
      });
      $[45] = t;
      $[46] = t19;
    } else {
      t19 = $[46];
    }
    let t20;
    if ($[47] !== t19) {
      t20 = <span className="pr-4 text-right">{t19}</span>;
      $[47] = t19;
      $[48] = t20;
    } else {
      t20 = $[48];
    }
    let t21;
    if ($[49] !== t) {
      t21 = t("product.customizeColQty", {
        defaultValue: "\u041A\u043E\u043B-\u0432\u043E, \u0448\u0442"
      });
      $[49] = t;
      $[50] = t21;
    } else {
      t21 = $[50];
    }
    let t22;
    if ($[51] !== t21) {
      t22 = <span className="text-center">{t21}</span>;
      $[51] = t21;
      $[52] = t22;
    } else {
      t22 = $[52];
    }
    let t23;
    if ($[53] !== t18 || $[54] !== t20 || $[55] !== t22) {
      t23 = <div className="grid grid-cols-[minmax(0,1fr)_88px_102px] border-b border-black/10 pt-2.5 pb-5 text-[14px] font-semibold leading-[18px] text-[#1F1F1F] sm:grid-cols-[minmax(0,1fr)_102px_102px]">{t18}{t20}{t22}</div>;
      $[53] = t18;
      $[54] = t20;
      $[55] = t22;
      $[56] = t23;
    } else {
      t23 = $[56];
    }
    let t24;
    if ($[57] !== fmt || $[58] !== onPick || $[59] !== options || $[60] !== picked || $[61] !== t) {
      let t25;
      if ($[63] !== fmt || $[64] !== onPick || $[65] !== picked || $[66] !== t) {
        t25 = option_0 => {
          const count = picked[option_0.name] ?? 0;
          return <li key={option_0.name} data-testid="customization-row" className={cn("grid min-h-[58px] grid-cols-[minmax(0,1fr)_88px_102px] items-center rounded-[29px] p-1 transition-colors sm:grid-cols-[minmax(0,1fr)_102px_102px]", count > 0 && "bg-osmix-tangelo/5 outline outline-[0.5px] outline-osmix-tangelo")}><span className="flex min-w-0 items-center">{option_0.photo ? <button type="button" onClick={() => setZoom(option_0.photo ?? null)} aria-label={t("product.customizePhoto", {
                defaultValue: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0444\u043E\u0442\u043E"
              })} className="relative size-[50px] shrink-0 overflow-hidden rounded-full outline-none focus-visible:ring-2 focus-visible:ring-ds-focus"><img src={option_0.photo} alt="" className="size-full object-cover" /><span className="absolute right-0 bottom-0 grid size-[18px] place-items-center rounded-full bg-black/50 text-white"><MaximizeIcon /></span></button> : null}<span className={cn("min-w-0 break-words text-[14px] leading-[18px] text-[#1F1F1F]", option_0.photo ? "pl-2" : "pl-3")}>{option_0.name}</span></span><span className="pr-4 text-right text-[14px] leading-[18px] whitespace-nowrap text-[#1F1F1F]">{fmt(option_0.minPrice)}</span><span className="flex items-center justify-center gap-2"><button type="button" onClick={() => onPick(option_0.name, Math.max(0, count - 1))} disabled={count === 0} aria-label={t("product.customizationLess", {
                defaultValue: "\u0423\u0431\u0440\u0430\u0442\u044C"
              })} className="grid size-6 place-items-center rounded-full text-[#1F1F1F] outline-none transition-opacity focus-visible:ring-2 focus-visible:ring-ds-focus disabled:opacity-30"><MinusCircleIcon /></button><span className="w-3 text-center text-[14px] leading-[18px] text-[#1F1F1F]">{count}</span><button type="button" onClick={() => onPick(option_0.name, count + 1)} aria-label={t("product.customizationMore", {
                defaultValue: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C"
              })} className="grid size-6 place-items-center rounded-full text-[#1F1F1F] outline-none focus-visible:ring-2 focus-visible:ring-ds-focus"><PlusCircleIcon /></button></span></li>;
        };
        $[63] = fmt;
        $[64] = onPick;
        $[65] = picked;
        $[66] = t;
        $[67] = t25;
      } else {
        t25 = $[67];
      }
      t24 = options.map(t25);
      $[57] = fmt;
      $[58] = onPick;
      $[59] = options;
      $[60] = picked;
      $[61] = t;
      $[62] = t24;
    } else {
      t24 = $[62];
    }
    let t25;
    if ($[68] !== t24) {
      t25 = <ul className="flex flex-col py-2.5">{t24}</ul>;
      $[68] = t24;
      $[69] = t25;
    } else {
      t25 = $[69];
    }
    if ($[70] !== t23 || $[71] !== t25) {
      t4 = <div className="min-h-0 flex-1 overflow-y-auto pt-5 pr-5 pb-5 pl-4 sm:pl-[30px]">{t23}{t25}</div>;
      $[70] = t23;
      $[71] = t25;
      $[72] = t4;
    } else {
      t4 = $[72];
    }
    t5 = chosen.length > 0 && <section data-testid="customization-summary" className="flex flex-col gap-3 py-2.5 pr-5 pl-4 sm:pl-[30px]" aria-live="polite"><h3 className="text-[16px] font-semibold leading-5 tracking-[-0.31px] text-black">{applying ? t("product.customizeApplying", {
          defaultValue: "\u0414\u043E\u0431\u0430\u0432\u043B\u044F\u0435\u043C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u0432 \u043A\u043E\u0440\u0437\u0438\u043D\u0443\u2026"
        }) : t("product.customizeAdded", {
          defaultValue: "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043E \u0432 \u043A\u043E\u0440\u0437\u0438\u043D\u0443"
        })}</h3><div className="flex flex-col gap-1.5 text-[14px] leading-[18px] text-black"><p className="flex justify-between gap-3"><span>{t("product.goodsCount", {
              count: Math.max(qty, 1)
            })}</span><span className="whitespace-nowrap">{fmt(goodsSum)}</span></p><p className="flex justify-between gap-3"><span>{t("product.customizeCount", {
              count: chosenCount,
              defaultValue: "\u041A\u0430\u0441\u0442\u043E\u043C\u0438\u0437\u0430\u0446\u0438\u044F, {{count}} \u0448\u0442"
            })}</span><span className="whitespace-nowrap">{fmt(chosenSum)}</span></p></div><p className="flex items-baseline justify-between gap-3 text-black"><span className="text-[14px] font-semibold leading-[18px]">{t("product.customizeTotal", {
            defaultValue: "\u0418\u0442\u043E\u0433\u043E"
          })}</span><span className="text-[20px] font-semibold leading-[23px] tracking-[-0.31px] whitespace-nowrap">{fmt(goodsSum + chosenSum)}</span></p></section>;
    $[0] = applying;
    $[1] = fmt;
    $[2] = onOpenChange;
    $[3] = onPick;
    $[4] = open;
    $[5] = options;
    $[6] = picked;
    $[7] = qty;
    $[8] = t;
    $[9] = unitPrice;
    $[10] = T0;
    $[11] = T1;
    $[12] = T2;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    T0 = $[10];
    T1 = $[11];
    T2 = $[12];
    t1 = $[13];
    t2 = $[14];
    t3 = $[15];
    t4 = $[16];
    t5 = $[17];
    t6 = $[18];
    t7 = $[19];
    t8 = $[20];
  }
  let t9;
  if ($[73] !== t) {
    t9 = t("product.customizeChat", {
      defaultValue: "\u0412 \u0447\u0430\u0442"
    });
    $[73] = t;
    $[74] = t9;
  } else {
    t9 = $[74];
  }
  let t10;
  if ($[75] !== onChat || $[76] !== t9) {
    t10 = <Button variant="gray" onClick={onChat} className="w-[150px]">{t9}</Button>;
    $[75] = onChat;
    $[76] = t9;
    $[77] = t10;
  } else {
    t10 = $[77];
  }
  let t11;
  if ($[78] !== onQty) {
    t11 = () => onQty(-1);
    $[78] = onQty;
    $[79] = t11;
  } else {
    t11 = $[79];
  }
  const t12 = qtyBusy || qty <= 0;
  let t13;
  if ($[80] !== t) {
    t13 = t("product.qtyLess", {
      defaultValue: "\u0423\u0431\u0440\u0430\u0442\u044C \u043E\u0434\u043D\u0443"
    });
    $[80] = t;
    $[81] = t13;
  } else {
    t13 = $[81];
  }
  let t14;
  if ($[82] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Minus20Icon />;
    $[82] = t14;
  } else {
    t14 = $[82];
  }
  let t15;
  if ($[83] !== t11 || $[84] !== t12 || $[85] !== t13) {
    t15 = <button type="button" onClick={t11} disabled={t12} aria-label={t13} className="grid size-8 place-items-center rounded-[8px] outline-none transition-colors hover:bg-white/10 focus-visible:ring-2 focus-visible:ring-white/40 disabled:opacity-60">{t14}</button>;
    $[83] = t11;
    $[84] = t12;
    $[85] = t13;
    $[86] = t15;
  } else {
    t15 = $[86];
  }
  let t16;
  if ($[87] !== qty) {
    t16 = <span className="text-[16px] font-semibold leading-[21px]">{qty}</span>;
    $[87] = qty;
    $[88] = t16;
  } else {
    t16 = $[88];
  }
  let t17;
  if ($[89] !== onQty) {
    t17 = () => onQty(1);
    $[89] = onQty;
    $[90] = t17;
  } else {
    t17 = $[90];
  }
  const t18 = qtyBusy || !canAddMore;
  let t19;
  if ($[91] !== t) {
    t19 = t("product.qtyMore", {
      defaultValue: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0435\u0449\u0451"
    });
    $[91] = t;
    $[92] = t19;
  } else {
    t19 = $[92];
  }
  let t20;
  if ($[93] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Plus20Icon />;
    $[93] = t20;
  } else {
    t20 = $[93];
  }
  let t21;
  if ($[94] !== t17 || $[95] !== t18 || $[96] !== t19) {
    t21 = <button type="button" onClick={t17} disabled={t18} aria-label={t19} className="grid size-8 place-items-center rounded-[8px] outline-none transition-colors hover:bg-white/10 focus-visible:ring-2 focus-visible:ring-white/40 disabled:opacity-60">{t20}</button>;
    $[94] = t17;
    $[95] = t18;
    $[96] = t19;
    $[97] = t21;
  } else {
    t21 = $[97];
  }
  let t22;
  if ($[98] !== t15 || $[99] !== t16 || $[100] !== t21) {
    t22 = <div data-testid="customization-stepper" className="flex h-12 w-[150px] items-center justify-between rounded-[12px] bg-ds-primary px-3 text-white">{t15}{t16}{t21}</div>;
    $[98] = t15;
    $[99] = t16;
    $[100] = t21;
    $[101] = t22;
  } else {
    t22 = $[101];
  }
  let t23;
  if ($[102] !== t10 || $[103] !== t22) {
    t23 = <footer className="flex justify-end gap-4 pt-2.5 pr-5 pb-[30px] pl-4 sm:pl-[30px]">{t10}{t22}</footer>;
    $[102] = t10;
    $[103] = t22;
    $[104] = t23;
  } else {
    t23 = $[104];
  }
  let t24;
  if ($[105] !== T0 || $[106] !== t1 || $[107] !== t2 || $[108] !== t23 || $[109] !== t3 || $[110] !== t4 || $[111] !== t5) {
    t24 = <T0 data-testid={t1} className={t2}>{t3}{t4}{t5}{t23}</T0>;
    $[105] = T0;
    $[106] = t1;
    $[107] = t2;
    $[108] = t23;
    $[109] = t3;
    $[110] = t4;
    $[111] = t5;
    $[112] = t24;
  } else {
    t24 = $[112];
  }
  let t25;
  if ($[113] !== T1 || $[114] !== t24 || $[115] !== t6) {
    t25 = <T1>{t6}{t24}</T1>;
    $[113] = T1;
    $[114] = t24;
    $[115] = t6;
    $[116] = t25;
  } else {
    t25 = $[116];
  }
  let t26;
  if ($[117] !== zoom) {
    t26 = zoom ? [zoom] : [];
    $[117] = zoom;
    $[118] = t26;
  } else {
    t26 = $[118];
  }
  const t27 = Boolean(zoom);
  let t28;
  if ($[119] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = () => setZoom(null);
    $[119] = t28;
  } else {
    t28 = $[119];
  }
  let t29;
  if ($[120] !== t26 || $[121] !== t27) {
    t29 = <PhotoZoom images={t26} index={0} open={t27} onClose={t28} onIndex={_temp4} />;
    $[120] = t26;
    $[121] = t27;
    $[122] = t29;
  } else {
    t29 = $[122];
  }
  let t30;
  if ($[123] !== T2 || $[124] !== t25 || $[125] !== t29 || $[126] !== t7 || $[127] !== t8) {
    t30 = <T2 open={t7} onOpenChange={t8}>{t25}{t29}</T2>;
    $[123] = T2;
    $[124] = t25;
    $[125] = t29;
    $[126] = t7;
    $[127] = t8;
    $[128] = t30;
  } else {
    t30 = $[128];
  }
  return t30;
}

/*
 * Товар с кастомизацией, но без таблицы изменений (кадр 3870:25479): после
 * «В корзину» — окно 440 r20 «Этот товар можно изменить», текст 16/20 и серая
 * «В чат» во всю ширину.
 */
function _temp4() {}
function _temp3(sum_0, row_1) {
  return sum_0 + row_1.minPrice * row_1.qty;
}
function _temp2(sum, row_0) {
  return sum + row_0.qty;
}
function _temp(row) {
  return row.qty > 0;
}
export function CustomizeInChatDialog(t0) {
  const $ = _c(29);
  const {
    open,
    onOpenChange,
    onChat
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("product.customizeTitle", {
      defaultValue: "\u042D\u0442\u043E\u0442 \u0442\u043E\u0432\u0430\u0440 \u043C\u043E\u0436\u043D\u043E \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C"
    });
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <DialogTitle className="min-w-0 flex-1 text-[20px] font-semibold leading-[23px] tracking-[-0.31px] text-[#161616]">{t1}</DialogTitle>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("common.close", {
      defaultValue: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
    });
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <XIcon />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3) {
    t5 = <DialogClose aria-label={t3} className="grid size-6 shrink-0 place-items-center rounded-[4px] text-[#1F1F1F] outline-none hover:text-osmix-tangelo focus-visible:ring-2 focus-visible:ring-ds-focus">{t4}</DialogClose>;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t5) {
    t6 = <div className="flex items-start gap-2.5 px-4 py-2.5">{t2}{t5}</div>;
    $[9] = t2;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t("product.customizeHint", {
      defaultValue: "\u0427\u0442\u043E\u0431\u044B \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0432 \u0442\u043E\u0432\u0430\u0440 \u043D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0443 \u0441\u0432\u043E\u0438 \u043F\u043E\u0436\u0435\u043B\u0430\u043D\u0438\u044F \u0432 \u0447\u0430\u0442\u0435."
    });
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <DialogDescription className="px-4 py-2.5 text-[16px] leading-5 text-[#1F1F1F]">{t7}</DialogDescription>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t) {
    t9 = t("product.customizeChat", {
      defaultValue: "\u0412 \u0447\u0430\u0442"
    });
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== onChat || $[19] !== t9) {
    t10 = <div className="px-4 pt-2.5 pb-4"><Button variant="gray" block={true} onClick={onChat}>{t9}</Button></div>;
    $[18] = onChat;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t6 || $[23] !== t8) {
    t11 = <DialogContent showCloseButton={false} data-testid="customize-in-chat" overlayClassName="bg-black/20 backdrop-blur-[3px]" className="w-[calc(100vw-32px)] max-w-[440px] gap-0 rounded-[20px] border-0 bg-white p-0 shadow-none sm:max-w-[440px]">{t6}{t8}{t10}</DialogContent>;
    $[21] = t10;
    $[22] = t6;
    $[23] = t8;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== onOpenChange || $[26] !== open || $[27] !== t11) {
    t12 = <Dialog open={open} onOpenChange={onOpenChange}>{t11}</Dialog>;
    $[25] = onOpenChange;
    $[26] = open;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
}